import { render, staticRenderFns } from "./post_process_data.vue?vue&type=template&id=97e2d51c&"
import script from "./post_process_data.vue?vue&type=script&lang=js&"
export * from "./post_process_data.vue?vue&type=script&lang=js&"
import style0 from "./post_process_data.vue?vue&type=style&index=0&id=97e2d51c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports